// 累加器
export function sumBy(func, list) {
  return list.reduce((sum, cur, curIndex) => sum + func.call(null, cur, curIndex), 0);
}

function calcOneYearMonthPrice({ firstYearPrice = 0, duration = 0, usedMonthNum = 0 }) {
  return sumMonthPrice(duration, usedMonthNum, firstYearPrice);
}

function calcTwoYearMonthPrice({ firstYearPrice = 0, secondYearPrice = 0, duration = 0, usedMonthNum = 0 }) {
  return sumMonthPrice(duration, usedMonthNum, firstYearPrice, secondYearPrice);
}

function calcThreeYearMonthPrice({
  firstYearPrice = 0,
  secondYearPrice = 0,
  thirdYearPrice = 0,
  duration = 0,
  usedMonthNum = 0,
}) {
  return sumMonthPrice(duration, usedMonthNum, firstYearPrice, secondYearPrice, thirdYearPrice);
}

function caclFourthYearMonthPrice({
  firstYearPrice = 0,
  secondYearPrice = 0,
  thirdYearPrice = 0,
  fourthYearPrice = 0,
  duration = 0,
  usedMonthNum = 0,
}) {
  return sumMonthPrice(duration, usedMonthNum, firstYearPrice, secondYearPrice, thirdYearPrice, fourthYearPrice);
}

function caclFifthYearMonthPrice({
  firstYearPrice = 0,
  secondYearPrice = 0,
  thirdYearPrice = 0,
  fourthYearPrice = 0,
  fifthYearPrice = 0,
  duration = 0,
  usedMonthNum = 0,
}) {
  return sumMonthPrice(
    duration,
    usedMonthNum,
    firstYearPrice,
    secondYearPrice,
    thirdYearPrice,
    fourthYearPrice,
    fifthYearPrice
  );
}
/**
 * 计算一年的价格
 * @param {Number} duration 总时长
 * @param {Number} yearPrice 年价格
 * @param {Number} curYear 当前年份
 */
function sumYearPrice(duration, usedMonthNum, yearPrice, curYear) {
  return fixPrice(getMonthPrice(yearPrice) * getYearMonthNumber(duration, usedMonthNum, curYear));
}

function sumMonthPrice(duration, usedMonthNum, ...priceList) {
  return sumBy((cur, index) => sumYearPrice(duration, usedMonthNum, cur, index), priceList);
}

function getYearMonthNumber(duration, usedMonthNum, curYearIndex) {
  const isFullYear = (duration, curYearIndex) => curYearIndex + 1 <= duration / 12;
  const isFullUsed = (usedMonthNum, curYearIndex) => curYearIndex + 1 <= usedMonthNum / 12;
  const isFullLastUsed = (usedMonthNum, curYearIndex) => curYearIndex <= usedMonthNum / 12;
  const monthDuration = isFullYear(duration, curYearIndex) ? 12 : duration % 12;
  const usedDuration = isFullUsed(usedMonthNum, curYearIndex) ? 12 : usedMonthNum % 12;
  if (isFullLastUsed(usedMonthNum, curYearIndex)) {
    // console.log(curYearIndex, monthDuration, usedDuration)
    return monthDuration - usedDuration;
  } else {
    // console.log(monthDuration);
    return monthDuration;
  }
}

function getMonthPrice(yearPrice) {
  return yearPrice / 12;
}

function fixPrice(price) {
  return Number(price.toFixed(2));
}

export default function calcPrice(product, inputDuration, type = 1) {
  let duration;
  if (type === 1) {
    // 缴费开通
    duration = product.duration;
  } else if (type === 2) {
    // 续费
    duration = inputDuration + product.usedMonthNum;
    product.duration = duration;
  }
  if (duration <= 12) {
    return calcOneYearMonthPrice(product);
  }
  if (duration > 12 && duration <= 24) {
    return calcTwoYearMonthPrice(product);
  }
  if (duration > 24 && duration <= 36) {
    return calcThreeYearMonthPrice(product);
  }
  if (duration > 36 && duration <= 48) {
    return caclFourthYearMonthPrice(product);
  }
  if (duration > 48 && duration <= 60) {
    return caclFifthYearMonthPrice(product);
  } else {
    return 0;
  }
}
